import type { Table } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import type { DataTableExport } from './export/hooks.js';
import { DataTableToolbarExport } from './export/index.js';
import { useStyles } from './styles.js';
import { DataTableToolbarViewOptions } from './view-options/index.js';

type DataTableToolbarProps<TData> = {
    table: Table<TData>;
    tableId: string;
    resetTableLayout: () => void;
    columnTitles: Partial<Record<keyof TData, string>>;
    columnOrder: string[];
    customActions?: ReactNode;
    dataExportFunc?: () => DataTableExport | null;
};

export function DataTableToolbar<TData>({
    table,
    tableId,
    resetTableLayout,
    columnTitles,
    columnOrder,
    customActions,
    dataExportFunc,
}: DataTableToolbarProps<TData>) {
    const styles = useStyles();

    return (
        <div className={styles.toolbar}>
            {customActions}

            <DataTableToolbarViewOptions
                tableId={tableId}
                table={table}
                resetTableLayout={resetTableLayout}
                columnTitles={columnTitles}
                columnOrder={columnOrder}
            />

            {dataExportFunc ? <DataTableToolbarExport dataExportFunc={dataExportFunc} /> : null}
        </div>
    );
}
